<template>
  <v-dialog
    width="700"
    content-class="white"
    :value="true"
    class="conversation"
  >
    <v-card rounded style="position: absolute; top: 100px; width: 700px">
      <div class="py-4 px-6">
        <span class="text-h5">New Chat</span>
      </div>
      <v-divider></v-divider>
      <v-form ref="newDM" class="py-4 px-6">
        <div v-if="organizations.length > 1">
          <h4>Organization</h4>
          <v-select
            class="input-field"
            outlined
            dense
            :disabled="sending"
            :placeholder="organizations.length ? 'Organization' : 'Loading...'"
            background-color="#F3F3F3"
            v-model="selectedOrganization"
            :items="organizations"
            item-text="orgName"
            item-value="orgId"
          />
        </div>
        <div v-if="organizations.length === 1">
          <h4>{{ organizations[0].orgName }}<br /></h4>
        </div>
        <h3
          v-show="!targetOrganization && organizations.length === 0"
          style="color: #666; text-align: center; padding: 20px;"
        >
          Loading...
        </h3>
        <div v-if="selectedOrganization">
          <h4>To</h4>
          <AvailableDMParticipantsSearch
            :disabled="sending"
            v-model="selectedUsers"
            :selectedOrganization="selectedOrganization"
            :targetUsers="targetUsers"
            @resetValidation="resetValidation"
          />
          <h4>Chat Group Name</h4>
          <v-text-field
            class="mb-2 input-field"
            background-color="#F3F3F3"
            placeholder="Conversation Name"
            outlined
            dense
            :disabled="sending"
            :value="conversationName"
            @input="name = $event"
            :rules="[rules.required, rules.maxChar64, rules.notOnlyBlankSpaces]"
          />
          <h4>Message</h4>
          <v-textarea
            class="mb-2 input-field"
            background-color="#F3F3F3"
            placeholder="Message..."
            outlined
            dense
            :disabled="sending"
            :value="message"
            @input="message = $event"
            :rules="[rules.required, rules.notOnlyBlankSpaces]"
          />
        </div>
      </v-form>
      <div class="d-flex justify-end pr-6">
        <v-btn class="mr-2" :disabled="sending" @click="$emit('closeDialog')"
          >Cancel</v-btn
        >
        <v-btn
          class="mb-2"
          v-if="!sending"
          :disabled="sending || selectedOrganization === null"
          @click="create"
          color="primary"
          >Create</v-btn
        >
        <v-btn class="mb-2" v-if="sending" :disabled="true" color="primary"
          >Sending...</v-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { createSendingMessage } from "../../helpers/chat";
import Avatar from "@/components/Avatar.vue";
import AvailableDMParticipantsSearch from "@/components/Chat/AvailableDMParticipantsSearch.vue";
import { createDm } from "@/helpers/api";
import { bus } from "@/main";
import { getOrganizationsUserHasAccessToChat } from "@/helpers/api";
import rules from "@/helpers/FieldValidationRules";
import { mapGetters } from "vuex";
import GetterTypes from "@/store/GetterTypes";

export default Vue.extend({
  name: "NewDMView",
  components: { AvailableDMParticipantsSearch },
  props: {
    targetUsers: { type: Array, required: false },
    targetOrganization: { type: String, required: false }
  },
  data() {
    return {
      organizations: [],
      selectedOrganization: null,
      selectedUsers: [],
      name: "",
      rules: rules,
      message: "",
      sending: false
    };
  },
  mounted() {
    this.getOrganizationsSelectors();
  },
  methods: {
    async getOrganizationsSelectors() {
      if (this.targetOrganization) {
        this.selectedOrganization = this.targetOrganization;
      } else {
        const resp = await getOrganizationsUserHasAccessToChat();
        this.organizations = resp.data;
        this.selectedOrganization = this.organizations[0].orgId;
      }
      bus.$emit("loadingOff");
      this.$emit("waitingOff");
    },
    buildUserIds() {
      let ids = [];
      this.selectedUsers.forEach(u => {
        ids = [...ids, ...u.users.map(user => user.id)];
      });
      return ids;
    },

    userStringBuilder(arr, charMax) {
      let str = arr.reduce((acc, cur, idx) => {
        return (acc += `${idx > 0 ? ", " : ""}${cur.name}`);
      }, "");

      str = str.length > 0 ? `${this.user.fullName}, ` + str : "";

      return str.length > charMax ? str.substring(0, 61) + "..." : str;
    },

    resetValidation() {
      this.$refs.newDM.resetValidation();
    },

    async create() {
      this.sending = true;
      try {
        const valid = this.$refs.newDM.validate();
        if (valid) {
          bus.$emit("loadingOn", "Loading...");
          const dmDto = {
            userIds: this.buildUserIds(),
            organizationId: this.selectedOrganization,
            channelName: this.conversationName,
            message: this.message
          };
          const resp = await createDm(dmDto);
          this.$emit("fetchConversations", resp.data.sid);
        }
      } catch (e) {
        alert("Error creating Chat.");
      } finally {
        this.sending = false;
      }
    }
  },
  computed: {
    conversationName() {
      return this.name === ""
        ? this.userStringBuilder(this.selectedUsers, 64)
        : this.name;
    },
    ...mapGetters({
      user: GetterTypes.GET_USER
    })
  }
});
</script>
<style scoped>
.input-field {
  box-sizing: border-box;
  border-radius: 10px;
  background-color: #ffffff;
}
</style>
